import React from 'react';
import CTA from '../../components/CTA';
import Breadcrumb from '../../components/Breadcrumb';

import bgImg from '../../assets/img/cta/cta-bg-2.png';
import featureImg1 from '../../assets/img/slider/gemasan-8.svg';

const ServiceDetailsRovMain = () => {
  return (
    <main>
      <Breadcrumb pageTitle="Ürünler" />

      <div className="service-details__area service-details__plr mt-110 mb-30">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-xl-10">
              <div className="service-details__item pt-40">
                <div className="service-details__section-box text-center pb-40">
                  <h4 className="section-subtitle">Ürünler</h4>
                  <h3 className="section-title">İnsansız Su Altı Robotu</h3>
                </div>
                <div className="row align-items-center mb-50">
                  <div className="col-xl-6 col-lg-6">
                    <div className="service-details__main-img">
                      <img src={featureImg1} alt="İnsansız Su Altı Robotu" style={{ width: '100%', height: 'auto' }} />
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-6">
                    <div className="service-details__text">
                      <p>
                        Gemilerin su altında kalan kısımlarının bakımı ve temizlik süreçlerinde aktif rol oynayan insansız su altı robotu. Operasyonel verimliliği artıran, derin deniz koşullarına dayanıklı teknoloji.
                      </p>
                      <p>
                        Gemi bakım ve temizlik süreçlerinde otonom çözümler sunan bu sistem, insan güvenliğini artırırken operasyonel maliyetleri düşürmektedir. Derin deniz koşullarında bile güvenilir şekilde çalışabilen teknolojimiz, denizcilik sektöründe yeni standartlar belirlemektedir.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="service-details__list">
                  <h4 className="mb-30">Özellikler</h4>
                  <ul>
                    <li>
                      <i className="fal fa-check-square"></i>
                      <span>Otonom operasyon kabiliyeti</span>
                    </li>
                    <li>
                      <i className="fal fa-check-square"></i>
                      <span>Derin deniz koşullarına dayanıklı yapı</span>
                    </li>
                    <li>
                      <i className="fal fa-check-square"></i>
                      <span>Yüksek çözünürlüklü kamera sistemi</span>
                    </li>
                    <li>
                      <i className="fal fa-check-square"></i>
                      <span>Gerçek zamanlı veri aktarımı</span>
                    </li>
                    <li>
                      <i className="fal fa-check-square"></i>
                      <span>Modüler tasarım</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CTA ctaBG={bgImg} />
    </main>
  );
};

export default ServiceDetailsRovMain;




